import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';

import { UserAgencyService } from '../services/UserAgency';
import AgencyRegistrationApplicationService from '../services/AgencyRegistrationApplications';

import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { AgencyCompanyContents } from '../components/tables/AgencyCompaniesTable';
import Information from '../components/modals/common/Information';
import { Confirmation } from '../components/modals/common';

import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import masterSlideLoader from '../utilities/masterSlideLoader';
import dialogLoader from '../utilities/dialogLoader';
import { messageUtility } from '../utilities/messageUtility';
import { isPrimaryCompanyRoleId } from '../utilities/roleUtility';
import {
  API_FLAG,
  HEADER_CONSTANTS,
  ONE_MASTER_FLAG,
  REQUEST_PARAMS,
} from '../utilities/constants';
import { MasterPageHeader } from '../components/PageHeader';
import AgencyRegistrationApplicationAttention, {
  DISPLAY_MODE,
} from '../components/AgencyRegistrationApplicationAttention';
import AgencyCompanyAgentManager from '../components/AgencyCompanyAgentManager';
import { param } from 'jquery';

export default class AgencyCompanies extends React.Component {
  constructor(props) {
    super(props);

    this.roleId = LocalStorageService.getRoleId(); // ロールID
    this.PartnerCompanyId = Number(
      SessionStorageService.getSessionPartnerCompanyIdOfPrimeCompany()
    ); // 自社ID

    // 元請ユーザーの場合、表示権限エラー画面に遷移
    if (isPrimaryCompanyRoleId(this.roleId)) {
      return window.location.replace('/error-permission');
    }

    this.searchButtonRef = React.createRef(); // 検索ボタン要素

    this.defaultParams = {
      selected_partner_company_id: this.PartnerCompanyId,
      // 検索条件
      name: '',
      address: '',
      tel: '',
      status: null,
    };

    this.state = {
      allLoaded: false,
      companies: [],
      firstLoad: false,
      isLoading: false,
      isOpened: true,
      pageTitle: '代行先一覧',
      params: { ...this.defaultParams },
      searchParams: { ...this.defaultParams },
      total: 0,
      showInfoDialog: false,
      infoDialog: {
        title: '権限エラー',
        message: '代行先の詳細は代行担当者のみ確認可能です。',
        buttonText: messageUtility.getMessage('I-000-017'),
      },
      showConfirmDialog: false,
      confirmDialog: {
        title: '代行関係解除',
        message: '',
        confirmButtonText: '代行関係解除',
        cancelButtonText: messageUtility.getMessage('I-000-017'),
        companyName: '',
      },
      showRevoked: false,
    };

    this.events = {
      search: {
        toggle: this.toggleSearchForm.bind(this), // 検索フォーム開閉イベント
        set: this.setSearchField.bind(this),
        clear: this.clearParams.bind(this),
        search: this.search.bind(this),
        toggleRevoke: this.toggleRevoke.bind(this),
        toggleExpired: this.toggleExpired.bind(this),
        toggleAboutToExpire: this.toggleAboutToExpire.bind(this),
      },
      table: {
        edit: this.companyPreview.bind(this), // 確認ボタン押下
        list: this.companyWorkers.bind(this), // 作業員一覧ボタン押下
        agency: this.companyAgency.bind(this), // 代行担当ボタン押下
        revoke: this.handleRevoke.bind(this), // 代行関係解除ボタン押下
      },
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  /**
   * 検索フォーム開閉
   */
  toggleSearchForm = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  toggleRevoke = () => {
    const params = { ...this.state.params };
    // change later to constant
    if (params.status !== 2) {
      params.status = 2;
    } else {
      params.status = null;
    }
    this.setState({ params });
  };

  toggleAboutToExpire = () => {
    const params = { ...this.state.params };
    this.setState({
      params: {
        ...this.state.params,
        has_about_to_expire: !this.state.params.has_about_to_expire,
      },
    });
  };

  toggleExpired = () => {
    const params = { ...this.state.params };
    this.setState({
      params: {
        ...this.state.params,
        has_expired: !this.state.params.has_expired,
      },
    });
  };

  setSearchField = e => {
    const params = { ...this.state.params };
    params[e.target.name] =
      e.target.name === 'personal_flag' ||
      e.target.name === 'has_partner' ||
      e.target.name === 'has_foreman'
        ? parseInt(e.target.value)
        : e.target.value;
    this.setState({ params });
  };

  /**
   * 検索条件クリア
   */
  clearParams = () => {
    this.setState(
      {
        loaded: false,
        companies: [],
        isFetch: true,
        isLoading: true,
        params: this.defaultParams,
        searchParams: this.defaultParams,
      },
      () => {
        this.requestCompanies();
      }
    );
  };

  search = () => {
    this.searchButtonRef.current.disabled = true;
    this.setState(
      prevState => ({
        loaded: false,
        companies: [],
        isFetch: true,
        isLoading: true,
        searchParams: prevState.params,
      }),
      this.requestCompanies()
    );
  };

  handleScroll = () => {
    if (this.state.loaded && !this.state.allLoaded) {
      this.requestCompanies(true);
    }
  };

  requestCompanies(isScroll = false) {
    this.setState({ isLoading: true }, () => {
      const { searchParams } = _.cloneDeep(this.state);
      if (searchParams.has_expired || searchParams.has_about_to_expire) {
        searchParams.status = 2;
      }
      const params = {
        ...searchParams,
        limit: REQUEST_PARAMS.parentLimit,
        offset: isScroll ? _.size(this.state.companies) : 0,
        isQuiet: true,
      };
      UserAgencyService.list(params).then(response => {
        if (response.result === true) {
          const data = response.data.entities.companies;
          const allLoaded = _.size(data) < params.limit;
          let companies = isScroll ? [...this.state.companies] : [];
          if (_.isEmpty(data) && isScroll) {
            this.setState({ loaded: true });
          } else {
            _.each(data, company => {
              companies.push(company);
            });
          }
          // 会社情報画面に遷移するために支店情報も取得
          this.setState({
            allLoaded,
            companies,
            total: response.data.total,
            isFetch: false,
            isLoading: false,
            loaded: true,
          });
        }
        if (!_.isNull(this.searchButtonRef.current)) {
          this.searchButtonRef.current.disabled = false;
        }
      });
    });
  }

  companyPreview = company => {
    if (_.has(company, 'is_agency') && !company.is_agency) {
      this.setState({
        showInfoDialog: true,
        infoDialog: {
          title: '権限エラー',
          message: '代行先の詳細は代行担当者のみ確認可能です。',
          buttonText: messageUtility.getMessage('I-000-017'),
        },
      });
    } else {
      // company.id → selected_partner_company_id
      const param = {
        state: {
          id: `${company.id}.${company.company_branch_id}`,
        },
      };
      SessionStorageService.setSessionSelectedPartnerCompanyId(company.id);
      SessionStorageService.setSessionSelectedPartnerCompanyName(company.name);
      masterSlideLoader.show('CompanyPreview', param);
    }
  };

  companyWorkers = company => {
    if (_.has(company, 'is_agency') && !company.is_agency) {
      this.setState({
        showInfoDialog: true,
        infoDialog: {
          title: '権限エラー',
          message: '代行先の詳細は代行担当者のみ確認可能です。',
          buttonText: messageUtility.getMessage('I-000-017'),
        },
      });
    } else {
      // company.id → selected_partner_company_id
      SessionStorageService.setSessionSelectedPartnerCompanyId(company.id);
      SessionStorageService.setSelectedPartnerCompanyAgencyRegistrationPermissionStatus(
        company.is_agency ? 1 : 0
      );
      masterSlideLoader.show('Workers', { state: {} });
    }
  };

  // 代行担当ボタン押下
  companyAgency = company => {
    dialogLoader.show(AgencyCompanyAgentManager, {
      state: {
        company,
        selected_partner_company_id: this.PartnerCompanyId,
      },
      callback: {
        close: () => {
          dialogLoader.close();
        },
        success: responses => {
          if (
            _.every(responses, response => {
              return !response || response.result === true;
            })
          ) {
            // 成功
            dialogLoader.close();
          } else {
            // 追加・削除が失敗した場合エラーメッセージを表示
            const messageTypes = ['registable', 'agency'];
            const messages = _.filter(
              _.map(responses, (response, index) => {
                if (!response) {
                  return;
                } else {
                  return {
                    status: response.status,
                    text: `${
                      response.data.message
                        ? response.data.message
                        : '完了しました。'
                    }`,
                    total: response.data.total ? response.data.total : 0,
                    type: messageTypes[index],
                  };
                }
              }),
              message => {
                return !_.isUndefined(message);
              }
            );
            let parsedMessage;
            if (
              _.some(messages, message => {
                return message.status === 0;
              }) &&
              _.some(messages, ['status', 403])
            ) {
              // エラーメッセージは編集ができたものとできなかったものが混在する場合
              const successful = _.find(messages, message => {
                return message.status === 0;
              });
              const error = _.find(messages, message => {
                return message.status === 403;
              });
              parsedMessage = (
                <React.Fragment>
                  選択した担当者に下記の理由で編集できないユーザーが含まれています。
                  <ul className='ApplyConfirmDialog__message--list'>
                    <li className='ApplyConfirmDialog__message--list-item'>
                      {error.text}
                    </li>
                  </ul>
                  その他{successful.total}件の更新は完了しました。
                </React.Fragment>
              );
            } else {
              // 成功なしのエラーメッセージ表示
              parsedMessage = <span>{messages[0]['text']}</span>;
            }
            this.setState({
              showInfoDialog: true,
              infoDialog: {
                title: 'エラー',
                message: parsedMessage,
                buttonText: messageUtility.getMessage('I-000-017'),
              },
            });
          }
        },
      },
    });
  };

  handleRevoke = company => {
    this.setState({
      showConfirmDialog: true,
      confirmDialog: {
        title: '代行関係解除',
        message: (
          <span>
            代行関係が解除されると、{company.name}のすべてのユーザーは
            {company.name}
            の代行操作が出来なくなります。再度代行操作を行う場合には、代行登録申請が必要です。
            <br />
            {company.name}との代行関係を解除してもよろしいですか？
          </span>
        ),
        confirmButtonText: '代行関係解除',
        cancelButtonText: '戻る',
        onConfirm: () => {
          this.revokeCompany(company);
        },
      },
    });
  };

  revokeCompany = company => {
    this.setState({ showConfirmDialog: false }, () => {
      const params = {
        ...this.state.params,
        company_agent_to: company.id,
      };
      AgencyRegistrationApplicationService.revoke(params).then(response => {
        if (response.result === true) {
          this.setState({
            showInfoDialog: true,
            infoDialog: {
              title: '代行関係解除完了',
              message: `${company.name}との代行関係を解除しました。`,
              buttonText: messageUtility.getMessage('I-000-017'),
            },
          });
        } else {
          if (response.status === 400) {
            this.setState({
              showInfoDialog: true,
              infoDialog: {
                title: 'エラー',
                message: response.data.message,
                buttonText: messageUtility.getMessage('I-000-017'),
              },
            });
          } else {
            this.setState({
              showInfoDialog: true,
              infoDialog: {
                title: '代行権限がありません',
                message:
                  '代行関係の解除は、代行担当者に設定されたユーザーのみが行えます。代行担当者にご依頼ください。',
                buttonText: messageUtility.getMessage('I-000-017'),
              },
            });
          }
        }
      });
    });
  };

  componentDidMount() {
    this.setState(
      {
        firstLoad: true,
      },
      () => {
        this.requestCompanies();
      }
    );
  }

  render() {
    const { pageTitle, total, isOpened, params } = this.state;
    const { events, searchButtonRef } = this;
    return (
      <div className='master-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} - {pageTitle}
          </title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={pageTitle}
            onClose={() => masterSlideLoader.close()}
          />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <div className='master-slide-view__menu' />
            <AgencyRegistrationApplicationAttention
              displayMode={DISPLAY_MODE.AgencyCompanies}
            />
            <SearchForm
              total={total}
              isOpened={isOpened}
              params={params}
              callbacks={events.search}
              searchButtonRef={searchButtonRef}
              showRevoked={this.state.showRevoked}
            />
            <div className='master-slide-view__body AgencyCompanies'>
              <div className='constructionlist__list'>
                <table className='table table--constructionlist__list'>
                  <thead className='table__header'>
                    <tr className='table__label'>
                      <td
                        className='value-table value-table--table__label'
                        style={{ minWidth: 140 }}
                      >
                        <div className='value-table__label'>代行先会社名</div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label'>住所</div>
                      </td>
                      <td
                        className='value-table value-table--table__label'
                        style={{ minWidth: 140 }}
                      >
                        <div className='value-table__label'>電話番号</div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label'>代行開始日</div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label'>詳細確認・編集</div>
                      </td>
                      <td className='value-table value-table--table__label'>
                        <div className='value-table__label'>代行関係解除</div>
                      </td>
                    </tr>
                  </thead>
                  <AgencyCompanyContents
                    data={this.state.companies}
                    callbacks={this.events}
                    params={this.state.params}
                  />
                </table>
                <InfinityScrollLoad
                  targetId={`infinityscroll-target`}
                  total={this.state.total}
                  isLoading={this.state.isLoading}
                  callback={this.handleScroll}
                  ignoreIndicator={true}
                />
              </div>
            </div>
          </div>
        </div>
        <Information
          visible={this.state.showInfoDialog}
          onClose={() => {
            this.setState(
              {
                showInfoDialog: false,
              },
              () => {
                this.requestCompanies();
              }
            );
          }}
          title={this.state.infoDialog.title}
          message={this.state.infoDialog.message}
          buttonText={this.state.infoDialog.buttonText}
          multilineText={true}
        />
        <Confirmation
          visible={this.state.showConfirmDialog}
          title={this.state.confirmDialog.title}
          message={this.state.confirmDialog.message}
          confirmButtonText={this.state.confirmDialog.confirmButtonText}
          cancelButtonText={this.state.confirmDialog.cancelButtonText}
          isNegative={true}
          onConfirm={this.state.confirmDialog.onConfirm}
          onCancel={() => {
            this.setState({
              showConfirmDialog: false,
            });
          }}
        />
      </div>
    );
  }
}

const SearchForm = ({
  total,
  isOpened,
  params,
  callbacks,
  searchButtonRef,
  showRevoked,
}) => (
  <div className='master-slide-view__searchform'>
    <div className='search-form'>
      <div className='search-form__header'>
        <div className='search-form__title'>
          検索条件（検索結果<span className='bold'>{total}</span>件)
        </div>
        <button
          id='accordion-toggle'
          className={isOpened ? 'accordion__btn show' : 'accordion__btn'}
          onClick={() => callbacks.toggle()}
        />
        <button className='btn-text--sm' onClick={() => callbacks.clear()}>
          検索条件クリア
        </button>
      </div>
      <div
        id='search-form-accordion'
        className={isOpened ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>代行先会社名</span>
                </div>
                <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-4 --col-xl-4'>
                  <input
                    type='text'
                    name='name'
                    placeholder='代行先会社名'
                    value={params.name}
                    onChange={e => callbacks.set(e)}
                  />
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>住所</span>
                </div>
                <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-4 --col-xl-4'>
                  <input
                    type='text'
                    name='address'
                    placeholder='住所'
                    value={params.address}
                    onChange={e => callbacks.set(e)}
                  />
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>電話番号</span>
                </div>
                <div className='form-element__element --col-xs-12 --col-md-12 --col-lg-4 --col-xl-4'>
                  <input
                    type='text'
                    name='tel'
                    placeholder='電話番号'
                    value={params.tel}
                    onChange={e => callbacks.set(e)}
                  />
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span className='label'>期限期間</span>
                </div>
                <div className='element__item'>
                  <div className='AgencyCompanies__checkbox'>
                    <label className='checkbox'>
                      <input
                        name='checkbox'
                        type='checkbox'
                        disabled={false}
                        checked={params.has_about_to_expire === true}
                        onChange={e => callbacks.toggleAboutToExpire(e)}
                      />
                      <i className='i-square i-3x' />
                      期限切れ間近情報あり
                    </label>
                  </div>
                  <div className='AgencyCompanies__checkbox'>
                    <label className='checkbox'>
                      <input
                        name='checkbox'
                        type='checkbox'
                        disabled={false}
                        checked={params.has_expired === true}
                        onChange={e => callbacks.toggleExpired(e)}
                      />
                      <i className='i-square i-3x' />
                      期限切れ情報あり
                    </label>
                  </div>
                </div>
              </div>
              <div className='form-element'>
                <div className='form-element__label'>
                  <span
                    className='label'
                    style={{ display: 'block', minHeight: 14 }}
                  />
                </div>
                <div className='element__item'>
                  <div className='AgencyCompanies__checkbox'>
                    <label className='checkbox'>
                      <input
                        name='checkbox'
                        type='checkbox'
                        disabled={false}
                        checked={params.status !== 2}
                        onChange={e => callbacks.toggleRevoke(e)}
                      />
                      <i className='i-square i-3x' />
                      解除済の会社を含める
                    </label>
                  </div>
                </div>
              </div>
              <div className='form-element' style={{ paddingTop: 34 }}>
                <button
                  className='btn--stay'
                  ref={searchButtonRef}
                  style={{
                    position: 'relative',
                  }}
                  onClick={callbacks.search}
                >
                  検索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/AgencyCompanies.jsx